import React from "react"
import parse from "html-react-parser"
import { StaticImage } from "gatsby-plugin-image"

import "./barnacle_seo_banner.scss"

const BarnacleSeoBanner = ( { sectionContent }) => {
  return (
    <div className="barnacle-content">
      <StaticImage
        loading="eager"
        className="white-right-arrow"
        layout="fixed"
        src="../../images/right-arrow.png"
        width={15}
        quality={100}
        alt="Right arrow"
      />
      {parse(sectionContent)}
      {/* <p className="paragraph-content">
        Check out what others are saying about our dental on Yelp.{' '}
        <u>
          Doctor Genius in Irvine, CA
        </u>
      </p> */}
    </div>
  )
}

export default BarnacleSeoBanner;
